import { useEffect } from 'react';

/**
 * Calls the given handler when a click occurs outside the provided elements.
 * @param {(HTMLElement | null | undefined)[]} elements Elements or refs that should not trigger the handler when clicked
 * @param {() => void} handler Function to call on outside click
 * @param {boolean} active Whether the handler should be active
 */
export default function useOutsideClick(elements, handler, active = true) {
  useEffect(() => {
    if (!active) {
      return undefined;
    }

    const handle = (event) => {
      const isInside = elements.some((el) => {
        const element = el && el.current !== undefined ? el.current : el;
        return element && element.contains(event.target);
      });
      if (!isInside) {
        handler();
      }
    };

    document.addEventListener('mousedown', handle);
    document.addEventListener('touchstart', handle);

    return () => {
      document.removeEventListener('mousedown', handle);
      document.removeEventListener('touchstart', handle);
    };
  }, [elements, handler, active]);
}
